import classNames from 'classnames';
import type { FullWidthProps, SharedComponentProps } from '../types';
import * as styles from './index.css';

type TextareaProps = SharedComponentProps<'textarea'> & FullWidthProps;

export function Textarea({ fullWidth, className, ...props }: TextareaProps) {
    return (
        <textarea className={classNames(styles.textarea, { [styles.fullWidth]: fullWidth }, className)} {...props} />
    );
}
